"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _compose = _interopRequireDefault(require("recompose/compose"));

var _styles = require("@material-ui/core/styles");

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _AppBar = _interopRequireDefault(require("@material-ui/core/AppBar"));

var _Toolbar = _interopRequireDefault(require("@material-ui/core/Toolbar"));

var _IconButton = _interopRequireDefault(require("@material-ui/core/IconButton"));

var _Tooltip = _interopRequireDefault(require("@material-ui/core/Tooltip"));

var _Menu = _interopRequireDefault(require("@material-ui/icons/Menu"));

var _LightbulbOutline = _interopRequireDefault(require("./svgIcons/LightbulbOutline"));

var _LightbulbFull = _interopRequireDefault(require("./svgIcons/LightbulbFull"));

var _AppDrawer = _interopRequireDefault(require("./AppDrawer"));

var _AppSearch = _interopRequireDefault(require("./AppSearch"));

var _reactRedux = require("react-redux");

var _actionTypes = _interopRequireDefault(require("./redux/actionTypes"));

var _pageContext = _interopRequireDefault(require("./templates/pageContext"));

var _AppTableOfContents = _interopRequireDefault(require("./AppTableOfContents"));

var DEFAULT_PAGE_TITLE = '6star DOCS';

var styles = function styles(theme) {
  var _title, _ref;

  return _ref = {
    root: {
      display: 'flex'
    },
    grow: {
      flex: '1 1 auto'
    },
    title: (_title = {
      fontSize: 16
    }, (0, _defineProperty2.default)(_title, theme.breakpoints.up('sm'), {
      fontSize: 24
    }), (0, _defineProperty2.default)(_title, "marginLeft", 12), (0, _defineProperty2.default)(_title, "flex", '0 1 auto'), (0, _defineProperty2.default)(_title, "fontWeight", theme.typography.fontWeightMedium), _title),
    drawer: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
      width: 240
    }),
    img: {
      width: 207,
      marginTop: 7
    },
    appBar: {
      transition: theme.transitions.create('width'),
      '@media print': {
        position: 'absolute'
      }
    },
    appBarHome: {
      boxShadow: 'none'
    },
    appBarShift: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
      width: 'calc(100% - 240px)'
    })
  }, (0, _defineProperty2.default)(_ref, "drawer", (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
    width: 240
  })), (0, _defineProperty2.default)(_ref, "navIconHide", (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
    display: 'none'
  })), _ref;
};

var _ref3 = _react.default.createElement(_Menu.default, null);

var _ref4 = _react.default.createElement(_AppSearch.default, null);

var _ref5 = _react.default.createElement(_LightbulbFull.default, null);

var _ref6 = _react.default.createElement(_LightbulbOutline.default, null);

var AppFrame =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(AppFrame, _React$Component);

  function AppFrame() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, AppFrame);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(AppFrame)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      mobileOpen: false
    };

    _this.handleDrawerOpen = function () {
      _this.setState({
        mobileOpen: true
      });
    };

    _this.handleDrawerClose = function () {
      _this.setState({
        mobileOpen: false
      });
    };

    _this.handleTogglePaletteType = function () {
      _this.props.dispatch({
        type: _actionTypes.default.THEME_CHANGE_PALETTE_TYPE,
        payload: {
          paletteType: _this.props.uiTheme.paletteType === 'light' ? 'dark' : 'light'
        }
      });
    };

    return _this;
  }

  (0, _createClass2.default)(AppFrame, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          children = _this$props.children,
          classes = _this$props.classes,
          uiTheme = _this$props.uiTheme;
      var title = '';
      var disablePermanent = false;
      var navIconClassName = '';
      var appBarClassName = classes.appBar;

      if (title === null) {
        // home route, don't shift app bar or dock drawer
        disablePermanent = true;
        appBarClassName += " ".concat(classes.appBarHome);
      } else {
        navIconClassName = classes.navIconHide;
        appBarClassName += " ".concat(classes.appBarShift);
      }

      return _react.default.createElement(_pageContext.default.Consumer, null, function (_ref2) {
        var data = _ref2.data,
            config = _ref2.config;
        return _react.default.createElement("div", {
          className: classes.root
        }, _react.default.createElement(_AppBar.default, {
          className: appBarClassName
        }, _react.default.createElement(_Toolbar.default, null, _react.default.createElement(_IconButton.default, {
          color: "inherit",
          "aria-label": "Open drawer",
          onClick: _this2.handleDrawerOpen,
          className: navIconClassName
        }, _ref3), title !== null && _react.default.createElement(_Typography.default, {
          className: classes.title,
          variant: "h5",
          color: "inherit",
          noWrap: true
        }, data.currentPage && data.currentPage.edges.length > 0 && data.currentPage.edges[0].node.context && data.currentPage.edges[0].node.context.title != null ? data.currentPage.edges[0].node.context.title : DEFAULT_PAGE_TITLE), _react.default.createElement("div", {
          className: classes.grow
        }), _ref4, _react.default.createElement(_Tooltip.default, {
          title: "Toggle light/dark theme",
          enterDelay: 300
        }, _react.default.createElement(_IconButton.default, {
          color: "inherit",
          onClick: _this2.handleTogglePaletteType,
          "aria-label": "Toggle light/dark theme"
        }, uiTheme.paletteType === 'light' ? _ref5 : _ref6)))), _react.default.createElement(_AppDrawer.default, {
          className: classes.drawer,
          disablePermanent: disablePermanent,
          onClose: _this2.handleDrawerClose,
          onOpen: _this2.handleDrawerOpen,
          mobileOpen: _this2.state.mobileOpen,
          currentPage: data.currentPage && data.currentPage.edges.length > 0 ? data.currentPage.edges[0].node : null,
          siteLogo: config.siteLogo
        }), _this2.props.tableOfContents ? _react.default.createElement(_AppTableOfContents.default, {
          className: classes.drawer,
          disablePermanent: disablePermanent,
          onClose: _this2.handleDrawerClose,
          onOpen: _this2.handleDrawerOpen,
          mobileOpen: _this2.state.mobileOpen,
          toc: _this2.props.tableOfContents,
          title: _this2.props.title
        }) : null, children);
      });
    }
  }]);
  return AppFrame;
}(_react.default.Component);

AppFrame.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node.isRequired,
  classes: _propTypes.default.object.isRequired,
  dispatch: _propTypes.default.func.isRequired,
  uiTheme: _propTypes.default.object.isRequired
} : {};

var _default = (0, _compose.default)((0, _styles.withStyles)(styles), (0, _reactRedux.connect)(function (state) {
  return {
    uiTheme: state.theme
  };
}))(AppFrame);

exports.default = _default;